module.exports = __webpack_public_path__ + "img/logo_s.9a042d21.png";